export enum AssessmentTypeEnum {
    Autodetect = 0,
    Self = 1,
    Leader = 2,         // vezető értékeli a beosztottat
    Peer = 3,
    Subordinate = 4     // beosztott értékeli a vezetőt
}